export const REGISTER_SECTION = 'REGISTER_SECTION';
export const UNREGISTER_SECTION = 'UNREGISTER_SECTION';
export const REGISTER_BLOCKNAME = 'REGISTER_BLOCKNAME';
export const UPDATE_BLOCKNAME = 'UPDATE_BLOCKNAME';
export const UNREGISTER_BLOCKNAME = 'UNREGISTER_BLOCKNAME';
export const SET_BLOCK_POSITION = 'anchored/SET_BLOCK_POSITION';
